export default (array, oldIndex, newIndex) => {
  const cloned = array.slice();
  cloned.splice(
    (newIndex < 0 ? cloned.length + newIndex : newIndex), 
    0, 
    cloned.splice(oldIndex, 1)[0]
  );
  return cloned;
}